import Vue from 'vue';
import Router from 'vue-router';

import Start from './views/Start/Start.vue';
import Employees from './views/Employees/Employees.vue';
import Planning from './views/Planning/Planning.vue';
import Projects from './views/Projects/Projects.vue';
import Authorize from './views/Authorize/Authorize.vue';
import Error404 from './views/Error404/Error404.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'root',
      component: Start,
    },
    {
      path: '/employees',
      name: 'employees',
      component: Employees,
    },
    {
      path: '/planning',
      name: 'planning',
      component: Planning,
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
    },
    {
      path: '/authorize',
      name: 'authorize',
      component: Authorize,
    },
    {
      path: '*',
      name: '404',
      component: Error404,
    },
  ],
});
